// A job as the installer sees it: name, where, when, what; a state pill on the
// right; an accent stripe on the left. No money on an internal crew's card; an
// external party's labour lives on the work order and the statement, not here.
import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { cn } from "@aiw/ui";
import type { InstallerJob } from "../lib/types";
import { Pill, type Tone } from "./Panel";

export function JobCard({ job, sub, pill, tone = "info", to, children, className }: { job: InstallerJob; sub?: ReactNode; pill?: ReactNode; tone?: Tone; to?: string; children?: ReactNode; className?: string }) {
  const STRIPE: Record<Tone, string> = { info: "border-l-primary", ok: "border-l-success", warn: "border-l-warning", bad: "border-l-destructive", plain: "border-l-border" };
  const head = (
    <div className="flex items-start gap-3 px-4 py-3">
      <div className="min-w-0 flex-1">
        <h3 className="font-display text-[17px] font-semibold leading-snug">{job.name ?? job.ref}</h3>
        {sub && <p className="mt-0.5 text-sm text-muted-foreground">{sub}</p>}
      </div>
      {pill && <Pill tone={tone} className="mt-0.5 shrink-0">{pill}</Pill>}
    </div>
  );
  return (
    <article className={cn("overflow-hidden rounded-lg border border-l-4 bg-card text-card-foreground", STRIPE[tone], className)}>
      {to ? <Link to={to} className="block min-h-[44px] active:bg-accent/50">{head}</Link> : head}
      {children && <div className="border-t px-4 py-3">{children}</div>}
    </article>
  );
}
